import { DatePipe } from '@angular/common';
import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbCalendar, NgbDate, NgbDateAdapter, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { AppStateProvider } from 'src/app/providers/app-state.provider';
import { DateService } from 'src/app/services/date.service';
import { VmsService } from 'src/app/services/vms.service';
import * as $ from 'jquery';

@Component({
  standalone: false,
  selector: 'app-invitation-rights',
  templateUrl: './invitation-rights.component.html',
  styleUrls: ['./invitation-rights.component.scss']
})
export class InvitationRightsComponent implements OnInit {
  openOptionDrawer: boolean = false;
  toDate: Date;
  selectedToDate: any;
  tDate: any;
  formattedSelectedToDate: any;
  fromDate: Date;
  fDate: any;
  selectedDate: any;
  formattedSelectedDate: any;
  searchText: string = '';
  companyList: any;
  multiSelectionCompanyName: any = [];
  selectedCompanyName: any;
  selctionlength: number;
  selectedId: any;
  historyList: any=[
    {
      id:0,
      name:['asf','sf']
    }
  ];
  page: any;
  tempHistoryList: any=[];
  pageSize: number=10;
  List:any=[
    {
      id:0,
    name:'All'
  },
  {
    id:1,
    name:'Pending'
  },
  {
    id:2,
    name:'Approved'
  },
  {
    id:3,
    name:'Rejected'
  }
  ]
  constructor(
    private router: Router,
    public datepipe: DatePipe,
    private appStateSrv: AppStateProvider,
    private zone: NgZone,
    private dateAdapter: NgbDateAdapter<string>,
    private ngbCalendar: NgbCalendar,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private dateSrv: DateService,
    private invSrv: VmsService
  ) {
    ngbDatepickerConfig.minDate = {
      year: 1970, month: 1, day: 1
    };

    ngbDatepickerConfig.outsideDays = 'visible';
  }

  ngOnInit(): void {
    const jsDate = new Date();
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear());
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear())
    this.fromDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.toDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.fDate = this.updateDateToCalendar();
    this.tDate = this.updateDateToCalendar();
    // this.getCompanyList();
    // this.getHistoryList();
  }

  openDrawer(id, item) {
    console.log(id)
    $('#' + id).find('.drawer-container').toggle();

  }
  hidePopup(){
    $(document).on("click", function () {
      $(".drawer-container").hide();
  });
  }

  // getCompanyList() {
  //   const data = {
  //     parkId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
  //     buildingId: ['3fa85f64-5717-4562-b3fc-2c963f66afa6'],
  //     isActive: true,
  //   };

  //   this.invSrv.getCompanyList(data).subscribe((res) => {
  //     this.companyList = res;
  //     const allOpt = {
  //       buildingId: null,
  //       tenantName: 'All',
  //     };
  //     this.companyList.unshift(allOpt);
  //     console.log(res);
  //     if (this.selectedId == null && this.companyList.length > 0) {
  //       this.selectedId = this.companyList[0].buildingId;
  //       this.selectCompanyName(this.companyList[0]);
  //     }
  //   });
  // }

  // getHistoryList() {
  //   console.log(this.multiSelectionCompanyName)
  //   const data = {
  //     resquestStatus: [true],
  //     fromDate: this.selectedDate,
  //     toDate: this.selectedToDate,
  //     search: this.multiSelectionCompanyName.length>0?this.selectedCompanyName:null,
  //     pageNo: 0,
  //     size: 0,
  //     invitationType: 'bulkInvite',
  //     parkTenantId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
  //     userId: 0,
  //   };
  //   this.invSrv.getHistoryDetail(data).subscribe((res) => {
  //     console.log(res);
  //     this.historyList=res.list;
  //     this.tempHistoryList=this.historyList
  //   });
  // }

  selectCompanyName(item) {

    if (item.id !== null)
      if (this.multiSelectionCompanyName.includes(item.id))
        this.multiSelectionCompanyName.splice(
          this.multiSelectionCompanyName.indexOf(item.id),
          1
        );
      else this.multiSelectionCompanyName.push(item.id);
    else this.multiSelectionCompanyName = [];

    let length = this.multiSelectionCompanyName.length - 1;
    this.selctionlength = length;
    this.selectedId = item.id;
    if (item.name != 'All') {
      this.selectedCompanyName = this.companyList.find(
        (x) =>
          x.id ==
          this.multiSelectionCompanyName[
            this.multiSelectionCompanyName.length - 1
          ]
      )?.name;
    } else {
      this.selectedCompanyName = item.tenantName;
    }
    // this.getHistoryList();
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  public async updateSelectedDate(date: NgbDate) {
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.fromDate = jsDate;
    this.fDate = this.updateDateToCalendar(date);
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(date.day, date.month - 1, date.year);
    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
      // this.getHistoryList();
      } else {
        this.zone.run(() => {
          this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
          this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear());
        this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear());
        this.fDate = this.updateDateToCalendar();
        this.tDate = this.updateDateToCalendar();
        });
        this.appStateSrv.showToast(
          'From date should not be greater than to date'
        );
        await delay(2000);
        // this.getHistoryList();
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }

  updateDateToCalendar(date?: NgbDate) {
    const updatedDate =
      date == undefined
        ? this.dateAdapter.toModel(this.ngbCalendar.getToday())!
        : this.dateAdapter.toModel(date)!;
    return updatedDate;
  }

  public async updateSelectedToDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    this.toDate = jsDate;
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(date.day, date.month - 1, date.year);
    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
        // this.getHistoryList();
      } else {
        this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
        this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear());
        this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear());
        this.fDate = this.updateDateToCalendar();
        this.tDate = this.updateDateToCalendar();
        this.appStateSrv.showToast(
          'From date should not be greater than to date'
        );
        await delay(2000);
        // this.getHistoryList();
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }


  handlePageChange(event) {
    console.log(event)
    this.page = event;
    console.log('pagination clicked');;
    this.historyList = this.tempHistoryList.slice(
      0,
      this.tempHistoryList.length < 10
        ? this.tempHistoryList.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }


}
